import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { Card, Popover, Badge } from "antd";
import { idConvocatorias } from "../../../../redux/actions/convocatoriaAction";
import { Convocatoria2 } from "../../../../models/ConvocatoriasModel/convocatoria.model";
import "./cards.style.scss";
import moment, { now } from "moment";
import apiMaestras from "../../../../api/Maestras/api-maestras";
import { ReactComponent as CalendarIcon } from "../../../../assets/calendar-detail.svg";
import apiDocumentos from "../../../../api/Documentos/api-documentos";
import ImageNotFound from "../../../../assets/enmascarar-detail.png";
import { textDecorationLine } from "html2canvas/dist/types/css/property-descriptors/text-decoration-line";

interface StateConvocatoria {
  convocatorias: Convocatoria2;
}

export const Cards: React.FC<StateConvocatoria> = (
  props: StateConvocatoria
) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [LineasConvocatorias, setLineasConvocatorias] = useState([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [dataImg, setDataImg] = useState<any>();

  const getLineasConvocatorias = async () => {
    const data = await apiMaestras.obtenerLineaConvocatoria();
    setLineasConvocatorias(data);
  }

  const getFilterLineaConvocatoria = (idLineaConvocatoria: number) => {
    const valueFilter = LineasConvocatorias.filter((x) => x.id === idLineaConvocatoria);
    if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) return valueFilter[0].nombre;
  }

  const getImageConvocatoria = async () => {
    if (props.convocatorias?.portada_url) {
      const data = await apiDocumentos.consultarArchivo(props.convocatorias?.portada_url);
      if (data && data.data) {
        setLoading(false)
        const reader = new FileReader();
        reader.readAsDataURL(data.data);
        reader.onloadend = function () {
          const base64String = reader.result;
          setDataImg(base64String);
        }
      }
    }
  }

  const calcularEstado = () => {
    var today = new Date();
    var year = today.getFullYear();
    var month = String(today.getMonth() + 1).padStart(2, '0');
    var day = String(today.getDate()).padStart(2, '0');
    var hours = String(today.getHours()).padStart(2, '0');
    var minutes = String(today.getMinutes()).padStart(2, '0');
    var formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
    var estado = 'Cerrada'; // Por defecto, considerar que está cerrada hasta que se demuestre lo contrario
    var inicio = props.convocatorias.fechas.filter((data) => data.clave === "Apertura")[0].valormin
    var cierre = props.convocatorias.fechas.find((data) => data.clave === "Cierre");
    if (cierre) {
        var valormax = new Date(cierre.valormax)
        valormax.setHours(valormax.getHours() - 1) // Resta una hora
        var year2 = valormax.getFullYear()
        var month2 = String(valormax.getMonth() + 1).padStart(2, '0')
        var day2 = String(valormax.getDate()).padStart(2, '0')
        var hours2 = String(valormax.getHours()).padStart(2, '0')
        var minutes2 = String(valormax.getMinutes()).padStart(2, '0')
        var formattedDate2 = `${year2}-${month2}-${day2} ${hours2}:${minutes2}`
      }

    if (inicio && cierre) {
      if (formattedDate >= inicio && formattedDate <= formattedDate2) {
        estado = 'Abierta'
      }
      else if(formattedDate <= inicio) {
        estado = 'En espera'
      }
      else {
        estado = 'Cerrada'
      }
      return estado
    }
  }


  useEffect(() => {
    getLineasConvocatorias();
  }, [])

  useEffect(() => {
    getImageConvocatoria();
  }, [props.convocatorias]);

  getFilterLineaConvocatoria(props.convocatorias.linea_convocatoria)

  return (
    <>
      <a
        href={`/estimuloscultura/verconvocatoria/${props.convocatorias.idconvocatorias}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          e.preventDefault(); // Evita la navegación predeterminada
          window.open(e.currentTarget.href, "_blank", "noopener,noreferrer"); // Abre en nueva pestaña
          dispatch(idConvocatorias(props.convocatorias.idconvocatorias)); // Lógica adicional
        }}
        style={{textDecoration: "none"}}
      >
        <Badge.Ribbon text={`Estado: ${calcularEstado()}`} color={`${calcularEstado() === 'Abierta' ? 'green' : calcularEstado() === 'En espera' ? 'Orange' : 'Black'}`}>
          <Card
            hoverable
            className="card-template-convocatoria-info"
            style={{ width: '100%', minHeight: '620px' }}
            cover={
              <img
                alt="example"
                className="card-image-detail-convocatoria"
                height={270}
                src={dataImg ? dataImg : ImageNotFound}
              />
            }
            loading={loading}
          >
            <div className="container-detalle-semibold font-weight-600" style={{ marginBottom: '20px', fontSize: '20px' }}>
              {
                getFilterLineaConvocatoria(props.convocatorias.linea_convocatoria) == undefined ? props.convocatorias.nombre_convocatoria : getFilterLineaConvocatoria(props.convocatorias.linea_convocatoria)
              }
            </div>

            <div className="row" >
              <div className="col-2 font-family-Montserrat-Regular font-size-13px font-weight-normal font-color-B0B0B0">
                <CalendarIcon style={{ fontSize: '40px' }} />
              </div>
              <div className="col font-family-Montserrat-Regular font-size-13px font-weight-normal font-color-FF8900">
                <div className="d-flex flex-column">
                  <div>
                    <strong className="cabecera-detalle-nombre-convocatoria" style={{ fontSize: '18px' }}>Inicia:{" "}</strong>
                  </div>
                  <div className="container-detalle-card-body-regular" style={{ fontSize: '18px' }}>
                    {props.convocatorias.fechas !== null &&
                      props.convocatorias.fechas.length > 0
                      ? props.convocatorias.fechas.filter(
                        (data) => data.clave === "Apertura"
                      ).length > 0
                        ? moment(props.convocatorias.fechas
                          .filter((data) => data.clave === "Apertura")[0]
                          .valormin.substring(0, 10)).format('DD MMM / YYYY')
                        : null
                      : null}
                  </div>
                </div>
              </div>
              <div className="col font-family-Montserrat-Regular font-size-13px font-weight-normal font-color-FF8900">
                <div className="d-flex flex-column">
                  <div>
                    <strong className="cabecera-detalle-nombre-convocatoria" style={{ fontSize: '18px' }}>Finaliza:{" "}</strong>
                  </div>
                  <div className="container-detalle-card-body-regular" style={{ fontSize: '18px' }}>
                    {props.convocatorias.fechas !== null &&
                      props.convocatorias.fechas.length > 0
                      ? props.convocatorias.fechas.filter(
                        (data) => data.clave === "Cierre"
                      ).length > 0
                        ? moment(props.convocatorias.fechas
                          .filter((data) => data.clave === "Cierre")[0]
                          .valormin.substring(0, 10)).format('DD MMM / YYYY')
                        : null
                      : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="">
              <span className="container-detalle-card-body-bold " style={{ fontSize: '18px' }}>
                Perfil:&nbsp;
              </span>
              <span className="container-detalle-card-body-regular" style={{ fontSize: '18px' }}>
                {props.convocatorias.tipo_participante.length > 0 &&
                  props.convocatorias.tipo_participante !== null
                  ? props.convocatorias.tipo_participante.map(
                    (data: any, index: number) => {
                      if (
                        props.convocatorias.tipo_participante.length -
                        1 ===
                        index
                      ) {
                        return ` ${data.text}`;
                      }
                      return `${data.text}, `;
                    }
                  )
                  : "No hay tipos de participante"}
              </span>
            </div>
            <div className="">
              <span className="container-detalle-card-body-bold " style={{ fontSize: '18px' }}>
                Entidad:&nbsp;
              </span>
              <span className="container-detalle-card-body-regular" style={{ fontSize: '18px' }}>
                {props.convocatorias.entidad}
              </span>
            </div>
            <div className="">
              <span className="container-detalle-card-body-bold " style={{ fontSize: '18px' }}>
                Área:&nbsp;
              </span>
              <span className="container-detalle-card-body-regular" style={{ fontSize: '18px' }}>
                {props.convocatorias.area.map(
                  (data: any, index: number) => {
                    if (props.convocatorias.area.length - 1 === index) {
                      return ` ${data && data.text !== null ? data.text : ''}`;
                    }
                    return `${data && data.text !== null ? data.text : ''}, `;
                  }
                )}
              </span>
            </div>
            <div className="">
              <span className="container-detalle-card-body-bold " style={{ fontSize: '18px' }}>
                Línea Estratégica:&nbsp;
              </span>
              <span className="container-detalle-card-body-regular" style={{ fontSize: '18px' }}>
                {props.convocatorias.linea_estrategica}
              </span>
            </div>
          </Card>
        </Badge.Ribbon>
      </a>
    </>
  );
};
